import * as React from 'react';
import { IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import InternalLink from 'components/Link/InternalLink';

interface OwnProps {
  to: {
    type: Nl.RouteMapType;
    payload?: any;
  };
  disabled?: boolean;
}

const EditButton: React.FunctionComponent<OwnProps> = ({ to, disabled }) => {
  return (
    <IconButton
      aria-label='Edit'
      color='default'
      disabled={disabled}
      data-e2e='editButton'
    >
      <InternalLink to={to} data-e2e='editButtonLink'>
        <EditIcon />
      </InternalLink>
    </IconButton>
  );
};

export default EditButton;
